import {
  LIVE_GW_URL,
  VZAN_STORE_BASE_URL,
  ZHIBO_URL,
} from '@/utils/http/baseUrl'
// * MODEL
import storeConfigModel from '@/controllers/storeController/models/config/config.model'
// * 大健康 - 门店系统相关控制器与组件
import StoreController from '@/controllers/storeController/view/store/store.controller.js'
// * 门店 - 相关接口
import $storeManagerApi from '@/controllers/storeController/api/storeManager.api'
// * 区域 - 相关接口
import $storeAreaManagerApi from '@/controllers/storeController/api/storeAreaManager.api'
// * 分公司 - 相关接口
import $storeCompanyManagerApi from '@/controllers/storeController/api/storeCompanyManager.api'

// * 大健康 java接口专用
const id_key_java = storeConfigModel.STORE_ID_KEY
const id_agent_java = storeConfigModel.STORE_AGENT_KEY
// * .net 接口专用
const id_key_net = storeConfigModel.STORE_ID_KEY_NET
/**
 * * 大健康门店系统 - api控制器
 * */
class StoreApiController {
  /**
   * * 一、接口分流
   */
  // * 获取 门店 & 区域 & 分公司 基础信息
  static async getCurrentBaseInfo() {
    const userType = StoreController.storeUserType()
    const apis = {
      0: $storeManagerApi.getCurrentStoreInfo,
      1: $storeAreaManagerApi.getCurrentRegionInfo,
      2: $storeCompanyManagerApi.getCurrentCompanyInfo,
    }
    return await apis[userType]({})
  }

  // * 获取门店，区域，分公司列表
  static async getDirectorBaseList() {
    const userType = StoreController.storeUserType()
    const apis = {
      0: $storeManagerApi.getDirectorStoreList,
      1: $storeAreaManagerApi.getAmRegionList,
      2: $storeCompanyManagerApi.getCompanyList,
    }
    return await apis[userType]({})
  }

  // * 获取门店代理，区域门店，分公司区域 列表数据
  static async getStoreHeaderTabList() {
    const userType = StoreController.storeUserType()
    const apis = {
      0: $storeManagerApi.getStoreAgentList,
      1: $storeAreaManagerApi.getAmStoreList,
      2: $storeCompanyManagerApi.getCompanyManagerRegionList,
    }
    const idKey = id_key_java[userType]
    const storeId = StoreController.storeId()
    let params = { zbId: window.zbvd.zbid }
    params[idKey] = storeId
    try {
      const res = await apis[userType](params)
      if (res && res.isok) {
        return res.dataObj
      }
      return []
    } catch (err) {
      console.log(e)
      return []
    }
  }

  // * 门店代理，区域门店，分公司区域 列表数据 key value 转换
  static storeHeaderTabKeyValue() {
    const userType = StoreController.storeUserType()
    const keys = {
      0: { label: 'agentName', value: 'agentId' },
      1: { label: 'title', value: 'id' },
      2: { label: 'title', value: 'id' },
    }
    return keys[userType]
  }

  // * 获取门店，区域，分公司 客户列表
  static async getCustomerManageInfo(data) {
    let params = JSON.parse(JSON.stringify(data))
    const storeId = StoreController.storeId()
    const userType = StoreController.storeUserType()
    const idKey = id_key_java[userType]
    const agentIdKey = id_agent_java[userType]
    params[agentIdKey] = params.ids
    params[idKey] = storeId
    delete params.ids
    return await $storeManagerApi.getCustomerManageInfoByStore(params)
  }

  // * 商品统计-获取商品统计
  static getProductStatByStore(data) {
    let params = JSON.parse(JSON.stringify(data))
    const userType = StoreController.storeUserType()
    const idKey = id_key_java[userType]
    const id = StoreController.storeId()
    params[idKey] = id
    return {
      url: `${VZAN_STORE_BASE_URL}/health/v1/h5/store/report/getProductStatListByStore`,
      params: params,
    }
  }

  // * 商品统计-获取商品统计-聚合
  static getProductStatSumByStore(data) {
    let params = JSON.parse(JSON.stringify(data))
    const userType = StoreController.storeUserType()
    const idKey = id_key_java[userType]
    const id = StoreController.storeId()
    params[idKey] = id
    return {
      url: `${VZAN_STORE_BASE_URL}/health/v1/h5/store/report/getProductStatSum`,
      params: params,
    }
  }

  // * 门店模块 客户列表 数据导出
  static exportCustomerManageInfoByStore(data) {
    let params = JSON.parse(JSON.stringify(data))
    const userType = StoreController.storeUserType()
    const id = StoreController.storeId()
    const idKey = id_key_java[userType]
    const agentIdKey = id_agent_java[userType]
    params[idKey] = id
    params[agentIdKey] = params.agentIds
    delete params.agentIds
    return {
      url: `${VZAN_STORE_BASE_URL}/health/v1/h5/store/manager/exportCustomerManageInfoByStore`,
      params: params,
    }
  }

  // * 下载中心接口
  static downloadTask(data) {
    let params = JSON.parse(JSON.stringify(data))
    return {
      url: `${ZHIBO_URL}/v1/download/task/pageStore`,
      params: params,
    }
  }

  /**
   * * 二、接口参数处理
   */
  // * 公共 参数处理
  static commonParams(params, RelationId = true) {
    const storeId = StoreController.storeId()
    const userType = StoreController.storeUserType()
    let data = {
      ...params,
      busType: storeConfigModel.STORE_BUS_TYPE[userType],
    }
    if (RelationId) data.relationId = storeId.toString()
    return data
  }

  // * 公共from 参数处理
  static commonFromParams(data) {
    let params = JSON.parse(JSON.stringify(data))
    const userType = StoreController.storeUserType()
    params = {
      ...params,
      from: storeConfigModel.STORE_FORM[userType],
    }
    params[id_key_net[userType]] = StoreController.storeId()
    return params
  }

  // * 代理/供应商 - 收益明细页 参数处理
  static getCommissonDetailListParams(data) {
    let params = JSON.parse(JSON.stringify(data))
    // Source: 4 门店  5 区域，6 分公司
    const userType = StoreController.storeUserType()
    const source = storeConfigModel.STORE_SOURCE[userType]
    const roleType = storeConfigModel.STORE_ROLE_TYPE[userType]
    params = {
      ...params,
      source,
      roleType,
      relationId: StoreController.storeId(),
      ruleType: 1,
    }
    params[id_key_net[userType]] = StoreController.storeId()
    // 区域和分公司 传storeId 和 storeRegionId
    if (userType) {
      if (params.agentIds?.[0]) {
        params[id_key_net[userType - 1]] = params.agentIds[0]
        delete params.agentIds
      }
      // 区域和分公司 分佣明细的source传7和8
      if (window.location.pathname.includes('/store/commission/')) {
        params.source = source + 2
      }
    }
    return params
  }

  // * 获取角色详情 参数处理
  static divideIntoRoleDetailsParams(data) {
    let params = JSON.parse(JSON.stringify(data))
    const userType = StoreController.storeUserType()
    const storeId = StoreController.storeId()
    return {
      ...params,
      dRoleType: storeConfigModel.STORE_DROLE_TYPE[userType],
      busType: storeConfigModel.STORE_BUS_TYPE[userType],
      relationId: storeId.toString(),
    }
  }

  // * 获取账号列表 参数处理
  static GetWxUserLianRegInfoListParams(data) {
    let params = JSON.parse(JSON.stringify(data))
    const userType = StoreController.storeUserType()
    const storeId = StoreController.storeId()
    return {
      ...params,
      busType: storeConfigModel.STORE_BUS_TYPE[userType],
      relationId: storeId.toString(),
    }
  }

  // * 获取连连用户账户信息 参数处理
  static getrealacctinfoParams(data) {
    let params = JSON.parse(JSON.stringify(data))
    const userType = StoreController.storeUserType()
    const storeId = StoreController.storeId()
    return {
      ...params,
      busType: storeConfigModel.STORE_BUS_TYPE[userType],
      relationId: storeId.toString(),
    }
  }

  // * 获取连连用户余额详情列表 参数处理
  static getbalancedetailslistParams(data) {
    let params = JSON.parse(JSON.stringify(data))
    const userType = StoreController.storeUserType()
    return {
      ...params,
      busType: storeConfigModel.STORE_BUS_TYPE[userType],
    }
  }

  // * 获取随机密码因子 参数处理
  static GetDrawRandomKeyParams(data) {
    let params = JSON.parse(JSON.stringify(data))
    const userType = StoreController.storeUserType()
    const storeId = StoreController.storeId()
    delete params.bustype
    return {
      ...params,
      busType: storeConfigModel.STORE_BUS_TYPE[userType],
      relationId: storeId.toString(),
    }
  }

  // * 获取用户代理订单列表 参数处理
  static GetMyAgentOrderListParams(data) {
    let params = JSON.parse(JSON.stringify(data))
    const userType = StoreController.storeUserType()
    const storeId = StoreController.storeId()
    if (userType === 0) params.selfTakeStoreId = storeId
    params[id_key_net[userType]] = storeId
    return {
      ...params,
      from: storeConfigModel.STORE_FORM[userType],
      storeId: 0,
    }
  }

  // * 代理-订单统计-获取最近N个搜索商品 参数处理
  static GetLatestSearchContentParams(data) {
    let params = JSON.parse(JSON.stringify(data))
    const userType = StoreController.storeUserType()
    const source = storeConfigModel.STORE_SOURCE[userType]
    return {
      ...params,
      source,
    }
  }

  // * 订单业绩导出 参数处理
  static ExportAgentOrderListParams(data) {
    let params = JSON.parse(JSON.stringify(data))
    const userType = StoreController.storeUserType()
    const storeId = StoreController.storeId()
    if (userType === 0) params.selfTakeStoreId = storeId
    params[id_key_net[userType]] = storeId
    return {
      ...params,
      from: storeConfigModel.STORE_FORM[userType],
      storeId: 0,
    }
  }

  // * 查询分佣数据看板 参数处理
  static GetCommissonDetailViewParams(data) {
    let params = JSON.parse(JSON.stringify(data))
    const userType = StoreController.storeUserType()
    const storeId = StoreController.storeId()
    const source = storeConfigModel.STORE_SOURCE[userType]
    const roleType = storeConfigModel.STORE_ROLE_TYPE[userType]
    params = {
      ...params,
      ruleType: 1,
      source,
      roleType,
      relationId: storeId,
    }
    params[id_key_net[userType]] = storeId
    // 区域和分公司 传storeId 和 storeRegionId
    if (userType) {
      if (params.agentIds?.[0]) {
        params[id_key_net[userType - 1]] = params.agentIds[0]
        delete params.agentIds
      }
      // 判断url路径
      if (window.location.pathname.includes('/store/commission/')) {
        params.source = source + 2
      }
    }
    return params
  }

  // * 获取发货单列表 参数处理
  static GetDeliveryProcureListParams(data) {
    let params = JSON.parse(JSON.stringify(data))
    const userType = StoreController.storeUserType()
    return {
      ...params,
      from: storeConfigModel.STORE_FORM[userType],
      [id_key_net[userType]]: StoreController.storeId(),
    }
  }

  // * 确认送达 参数处理
  static ConfirmDeliveredParams(data) {
    let params = JSON.parse(JSON.stringify(data))
    const userType = StoreController.storeUserType()
    params = {
      ...params,
      from: storeConfigModel.STORE_FORM[userType],
    }
    params[id_key_net[userType]] = StoreController.storeId()
    return params
  }

  static verifiedListParams(data) {
    let params = JSON.parse(JSON.stringify(data))
    const userType = StoreController.storeUserType()
    params = {
      ...params,
      from: storeConfigModel.STORE_FORM[userType],
    }
    params[id_key_net[userType]] = StoreController.storeId()
    return params
  }

  // * 发货单导出接口 参数处理
  static StoreExportOrderParams(data) {
    let params = JSON.parse(JSON.stringify(data))
    const userType = StoreController.storeUserType()
    params = {
      ...params,
      from: storeConfigModel.STORE_FORM[userType],
    }
    params[id_key_net[userType]] = StoreController.storeId()
    return params
  }

  // * 消耗积分
  static PostOperateAgentIntegerParams(data) {
    let params = JSON.parse(JSON.stringify(data))
    const userType = StoreController.storeUserType()
    params = {
      ...params,
      from: storeConfigModel.STORE_FORM[userType],
    }
    params[id_key_net[userType]] = StoreController.storeId()
    return params
  }
}

export default StoreApiController
